import React from 'react';
import { StickerBar } from './sticker-bar';

function RcgActionsARealiser({ rcgAction }) {
    if (!rcgAction) return null;

    return (
        <div className={"panel-card"}>
            <p className={"rcg-card-title"}>Actions à réaliser</p>

            <div className={`action-title-card action-title-card--${rcgAction.stickerType}`}>
                <strong className={"action-title-perf"}>{rcgAction.label}</strong>
            </div>
           <span className={"action-title-sticker-label"}>Étiquette :</span>
            <StickerBar stickerLabel={rcgAction.stickerLabel} stickerType={rcgAction.stickerType} />

            <div className={"instructions-section"}>
                <span className={"section-label"}>Instructions</span>
                <ul className={"instructions-list"}>
                    {rcgAction.modeOperatoire.map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}


export { RcgActionsARealiser };
